// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: var(--ca-text-primary, #172033);
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.import-dialog {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  background: var(--ca-surface, #fff);
  border-radius: var(--ca-radius-lg, 12px);
}

.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
}
.header-icon mat-icon {
  width: 23px;
  height: 23px;
  font-size: 23px;
}
.header-icon.header-icon--error {
  color: var(--ca-danger, #dc3545);
  background: var(--ca-danger-bg, #fdecef);
}

.header-copy {
  flex: 1;
  min-width: 0;
}
.header-copy h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 650;
  line-height: 1.35;
}
.header-copy p {
  margin: 3px 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
  overflow-wrap: anywhere;
}
.header-copy .source-name {
  font-weight: 600;
}

.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--ca-text-secondary, #4b5870);
  cursor: pointer;
}
.icon-button:hover:not(:disabled) {
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-primary, #0e2e80);
}
.icon-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.dialog-body {
  padding: 20px 22px 22px;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 8px 22px;
  text-align: center;
}
.loading-state p {
  margin: 14px 0 4px;
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--ca-text-primary, #172033);
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid var(--ca-border-light, #e9edf3);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

.muted-text {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.76rem;
}

.result-status {
  display: flex;
  gap: 10px;
  padding: 12px 13px;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-bg, #f5f7fb);
  color: var(--ca-text-secondary, #4b5870);
}
.result-status > mat-icon {
  flex: 0 0 auto;
  color: var(--ca-text-tertiary, #6f7b91);
  margin-top: 1px;
}
.result-status strong {
  display: block;
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
  font-weight: 650;
}
.result-status p {
  margin: 3px 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.77rem;
  line-height: 1.45;
}
.result-status.result-status--changed {
  border-color: var(--ca-success-border, #b7e3ca);
  background: var(--ca-success-bg, #eaf7f0);
}
.result-status.result-status--changed > mat-icon {
  color: var(--ca-success, #198754);
}

.summary-list {
  display: grid;
  gap: 9px;
  margin: 15px 0;
}

.summary-item {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  font-size: 0.81rem;
  line-height: 1.45;
  color: var(--ca-text-primary, #172033);
}
.summary-item mat-icon {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  font-size: 18px;
  color: var(--ca-success, #198754);
}
.summary-item.summary-item--unchanged mat-icon {
  color: var(--ca-text-tertiary, #6f7b91);
}

.count-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
  margin-top: 16px;
}

.count-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 11px 10px;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 9px;
  background: var(--ca-surface, #fff);
}

.count-value {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.1;
  color: var(--ca-text-primary, #172033);
}

.count-label {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.68rem;
  line-height: 1.25;
}

.count-card--inserted .count-value,
.count-card--restored .count-value {
  color: var(--ca-success, #198754);
}

.count-card--updated .count-value {
  color: var(--ca-primary, #0e2e80);
}

.count-card--deleted .count-value {
  color: var(--ca-danger, #dc3545);
}

.error-state {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px;
  border: 1px solid var(--ca-danger-border, #f3b9c0);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}
.error-state mat-icon {
  flex: 0 0 auto;
}
.error-state p {
  margin: 1px 0 0;
  color: var(--ca-danger, #dc3545);
  font-size: 0.83rem;
  line-height: 1.5;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0 22px 20px;
}

.btn {
  min-height: 38px;
  padding: 0.55rem 1.15rem;
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}
.btn-primary:hover {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 480px) {
  .dialog-header,
  .dialog-body {
    padding-left: 16px;
    padding-right: 16px;
  }
  .count-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dialog-footer {
    padding-left: 16px;
    padding-right: 16px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 1.5s;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/data-asset-capture/data-assets-capture-for-asset-source/data-assets-capture-for-asset-source.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sCAAA;EACA,uGAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,wDAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,iCAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AACJ;AAEE;EACE,gCAAA;EACA,wCAAA;AAAJ;;AAIA;EACE,OAAA;EACA,YAAA;AADF;AAGE;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AADJ;AAIE;EACE,eAAA;EACA,wCAAA;EACA,kBAAA;EACA,uBAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;AAJF;AAME;EACE,2CAAA;EACA,iCAAA;AAJJ;AAOE;EACE,mBAAA;EACA,YAAA;AALJ;;AASA;EACE,uBAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AANF;AAQE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sCAAA;AANJ;;AAUA;EACE,WAAA;EACA,YAAA;EACA,iDAAA;EACA,4CAAA;EACA,kBAAA;EACA,qCAAA;AAPF;;AAUA;EACE,oCAAA;EACA,kBAAA;AAPF;;AAUA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,iDAAA;EACA,uCAAA;EACA,iCAAA;EACA,wCAAA;AAPF;AASE;EACE,cAAA;EACA,uCAAA;EACA,eAAA;AAPJ;AAUE;EACE,cAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AARJ;AAWE;EACE,eAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AATJ;AAYE;EACE,+CAAA;EACA,yCAAA;AAVJ;AAYI;EACE,iCAAA;AAVN;;AAeA;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAZF;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,sCAAA;AAZF;AAcE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAZJ;AAeE;EACE,uCAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,kBAAA;EACA,mCAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;AAdF;;AAiBA;EACE,wCAAA;EACA,kBAAA;EACA,iBAAA;AAdF;;AAiBA;;EAEE,iCAAA;AAdF;;AAiBA;EACE,iCAAA;AAdF;;AAiBA;EACE,gCAAA;AAdF;;AAiBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,kDAAA;EACA,uCAAA;EACA,wCAAA;EACA,gCAAA;AAdF;AAgBE;EACE,cAAA;AAdJ;AAiBE;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,wBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AAhBF;AAkBE;EACE,6CAAA;EACA,2CAAA;AAhBJ;;AAoBA;EACE;IAAK,yBAAA;EAhBL;AACF;AAkBA;EACE;;IAEE,kBAAA;IACA,mBAAA;EAhBF;EAmBA;IACE,gDAAA;EAjBF;EAoBA;IACE,kBAAA;IACA,mBAAA;EAlBF;AACF;AAqBA;EACE;IAAW,wBAAA;EAlBX;AACF","sourcesContent":[":host {\n  display: block;\n  color: var(--ca-text-primary, #172033);\n  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n}\n\n.import-dialog {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  background: var(--ca-surface, #fff);\n  border-radius: var(--ca-radius-lg, 12px);\n}\n\n.dialog-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 22px 16px;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.header-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 42px;\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  background: #edf3ff;\n  color: var(--ca-primary, #0e2e80);\n\n  mat-icon {\n    width: 23px;\n    height: 23px;\n    font-size: 23px;\n  }\n\n  &.header-icon--error {\n    color: var(--ca-danger, #dc3545);\n    background: var(--ca-danger-bg, #fdecef);\n  }\n}\n\n.header-copy {\n  flex: 1;\n  min-width: 0;\n\n  h2 {\n    margin: 0;\n    color: var(--ca-text-primary, #172033);\n    font-size: 1.05rem;\n    font-weight: 650;\n    line-height: 1.35;\n  }\n\n  p {\n    margin: 3px 0 0;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.78rem;\n    overflow-wrap: anywhere;\n  }\n\n  .source-name {\n    font-weight: 600;\n  }\n}\n\n.icon-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--ca-text-secondary, #4b5870);\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: var(--ca-bg-secondary, #eef2f8);\n    color: var(--ca-primary, #0e2e80);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n}\n\n.dialog-body {\n  padding: 20px 22px 22px;\n}\n\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 18px 8px 22px;\n  text-align: center;\n\n  p {\n    margin: 14px 0 4px;\n    font-size: 0.92rem;\n    font-weight: 600;\n    color: var(--ca-text-primary, #172033);\n  }\n}\n\n.spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid var(--ca-border-light, #e9edf3);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: spin 0.75s linear infinite;\n}\n\n.muted-text {\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.76rem;\n}\n\n.result-status {\n  display: flex;\n  gap: 10px;\n  padding: 12px 13px;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-bg, #f5f7fb);\n  color: var(--ca-text-secondary, #4b5870);\n\n  > mat-icon {\n    flex: 0 0 auto;\n    color: var(--ca-text-tertiary, #6f7b91);\n    margin-top: 1px;\n  }\n\n  strong {\n    display: block;\n    color: var(--ca-text-primary, #172033);\n    font-size: 0.84rem;\n    font-weight: 650;\n  }\n\n  p {\n    margin: 3px 0 0;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.77rem;\n    line-height: 1.45;\n  }\n\n  &.result-status--changed {\n    border-color: var(--ca-success-border, #b7e3ca);\n    background: var(--ca-success-bg, #eaf7f0);\n\n    > mat-icon {\n      color: var(--ca-success, #198754);\n    }\n  }\n}\n\n.summary-list {\n  display: grid;\n  gap: 9px;\n  margin: 15px 0;\n}\n\n.summary-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  font-size: 0.81rem;\n  line-height: 1.45;\n  color: var(--ca-text-primary, #172033);\n\n  mat-icon {\n    flex: 0 0 auto;\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n    color: var(--ca-success, #198754);\n  }\n\n  &.summary-item--unchanged mat-icon {\n    color: var(--ca-text-tertiary, #6f7b91);\n  }\n}\n\n.count-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 9px;\n  margin-top: 16px;\n}\n\n.count-card {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  padding: 11px 10px;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 9px;\n  background: var(--ca-surface, #fff);\n}\n\n.count-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  line-height: 1.1;\n  color: var(--ca-text-primary, #172033);\n}\n\n.count-label {\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.68rem;\n  line-height: 1.25;\n}\n\n.count-card--inserted .count-value,\n.count-card--restored .count-value {\n  color: var(--ca-success, #198754);\n}\n\n.count-card--updated .count-value {\n  color: var(--ca-primary, #0e2e80);\n}\n\n.count-card--deleted .count-value {\n  color: var(--ca-danger, #dc3545);\n}\n\n.error-state {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 14px;\n  border: 1px solid var(--ca-danger-border, #f3b9c0);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n\n  mat-icon {\n    flex: 0 0 auto;\n  }\n\n  p {\n    margin: 1px 0 0;\n    color: var(--ca-danger, #dc3545);\n    font-size: 0.83rem;\n    line-height: 1.5;\n  }\n}\n\n.dialog-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 22px 20px;\n}\n\n.btn {\n  min-height: 38px;\n  padding: 0.55rem 1.15rem;\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n\n  &:hover {\n    border-color: var(--ca-primary-dark, #0d2863);\n    background: var(--ca-primary-dark, #0d2863);\n  }\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 480px) {\n  .dialog-header,\n  .dialog-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .count-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .dialog-footer {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner { animation-duration: 1.5s; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
